import React from "react";
import BlogsList from "./blogsList";
import DashboardLayout from "../DashboardLayout";

const Blogs = ({ granted }) => {
  return (
    <DashboardLayout>
      <div className="row">
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Management</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#d1cdcdbf" }}
                >
                  Blogs
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4" data-testid="BlogsManagement">
        <BlogsList granted={granted} />
      </div>
    </DashboardLayout>
  );
};

export default Blogs;
